// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import type React from "react";

export const InfoIcon: React.FC = () => (
  <svg
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="currentColor"
    aria-hidden="true"
  >
    <circle cx="4" cy="1.5" r="1.5" />
    <rect x="2.5" y="5" width="3" height="9" rx="1.5" />
  </svg>
);
